import React from 'react';
import PropTypes from 'prop-types';

const SelectedPersonsCounter = props => {
  const value = props.selectedPersons?.length ?? 0;
  if (value === 0) {
    return null;
  }

  const type = [];
  switch (props.label) {
    case 'person':
      type.push('person', 'persons');
      break;
    case 'photo':
      type.push('photo', 'photos');
      break;
    case 'record':
      type.push('record', 'records');
      break;
    default:
      type.push('item', 'items');
      break;
  }

  let label = `1 ${type[0]} selected`;
  if (value > 1) {
    label = `${value} ${type[1]} selected`;
  }

  return <span className="mr-1">{label}</span>;
};

SelectedPersonsCounter.defaultProps = {
  label: 'person',
  selectedPersons: [],
};

SelectedPersonsCounter.propTypes = {
  label: PropTypes.string,
  selectedPersons: PropTypes.array,
};

export default SelectedPersonsCounter;
